"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericBadge = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var colors_1 = require("../colors");
var Text_1 = require("../components/Text");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    base: function (props) { return ({
        backgroundColor: props.badgeBackgroundColor ? (0, colors_1.getColor)(props.badgeBackgroundColor) : (0, colors_1.getColor)('WHITE_100'),
        width: 'fit-content',
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
    }); },
    big: {
        padding: '5px 8px',
    },
    small: {
        padding: '1px 6px',
    },
    icon: {
        marginRight: 8,
        marginBottom: 4,
    },
}); });
var GenericBadge = function (_a) {
    var children = _a.children, className = _a.className, icon = _a.icon, iconColor = _a.iconColor, badgeBackgroundColor = _a.badgeBackgroundColor, textVariant = _a.textVariant, textColor = _a.textColor, size = _a.size, iconSize = _a.iconSize;
    var classes = useStyles({ badgeBackgroundColor: badgeBackgroundColor });
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.base, className, classes[size]) },
        icon ? react_1.default.createElement("div", { className: classes.icon }, icon({ color: iconColor, size: iconSize })) : null,
        react_1.default.createElement(Text_1.Text, { variant: textVariant, color: textColor }, children)));
};
exports.GenericBadge = GenericBadge;
